import { determineApiAddress } from "@/vf"

export function assetLink(path: string) {
    if (path[0] == "/") path = path.substring(1)
    return `//${determineApiAddress()}/${path}`
}
